module.exports = __webpack_public_path__ + "static/media/testimonial2.ac4ab5e9.jpg";